(function () {
  var namespace = 'TCEHomeR3Carousel';
  var selector = '[data-r3-hero-carousel]';
  var instances = new Map();
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function findCarousels(root) {
    var carousels = [];
    if (root instanceof Element && root.matches(selector)) carousels.push(root);
    if (root.querySelectorAll) carousels = carousels.concat(Array.from(root.querySelectorAll(selector)));
    return carousels;
  }

  function createCarousel(carousel) {
    if (instances.has(carousel)) return;

    var slides = Array.from(carousel.querySelectorAll('[data-r3-slide]'));
    var dots = Array.from(carousel.querySelectorAll('[data-r3-dot]'));
    var previous = carousel.querySelector('[data-r3-prev]');
    var next = carousel.querySelector('[data-r3-next]');
    if (slides.length < 2 || !previous || !next) return;

    var index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var timer = null;
    var leavingTimer = null;
    var paused = false;
    var listeners = [];

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      listeners.push(function () { target.removeEventListener(type, handler, options); });
    }

    function clearTimers() {
      window.clearTimeout(timer);
      window.clearTimeout(leavingTimer);
      timer = null;
      leavingTimer = null;
    }

    function schedule() {
      window.clearTimeout(timer);
      timer = null;
      if (paused || reducedMotion.matches || document.hidden) return;
      timer = window.setTimeout(function () { show(index + 1, false); }, 6800);
    }

    function preloadNext() {
      var upcoming = slides[(index + 1) % slides.length];
      if (!upcoming || upcoming.dataset.r3Preloaded === 'true') return;
      var source = window.matchMedia('(max-width: 749px)').matches
        ? upcoming.dataset.r3MobileSrc
        : upcoming.dataset.r3DesktopSrc;
      if (!source) return;
      var image = new Image();
      image.src = source;
      upcoming.dataset.r3Preloaded = 'true';
    }

    function show(requestedIndex, manual) {
      var nextIndex = (requestedIndex + slides.length) % slides.length;
      if (nextIndex === index) {
        schedule();
        return;
      }

      window.clearTimeout(leavingTimer);
      var current = slides[index];
      var incoming = slides[nextIndex];
      current.classList.remove('is-active');
      current.classList.add('is-leaving');
      current.setAttribute('aria-hidden', 'true');
      incoming.classList.remove('is-leaving');
      incoming.classList.add('is-active');
      incoming.setAttribute('aria-hidden', 'false');

      dots.forEach(function (dot, dotIndex) {
        if (dotIndex === nextIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });

      index = nextIndex;
      leavingTimer = window.setTimeout(function () {
        slides.forEach(function (slide, slideIndex) {
          if (slideIndex !== index) slide.classList.remove('is-leaving');
        });
      }, reducedMotion.matches ? 140 : 1100);

      preloadNext();
      if (manual) paused = carousel.matches(':hover') || carousel.matches(':focus-within');
      schedule();
    }

    function setPaused(value) {
      paused = value;
      if (paused) window.clearTimeout(timer);
      else schedule();
    }

    listen(previous, 'click', function () { show(index - 1, true); });
    listen(next, 'click', function () { show(index + 1, true); });
    dots.forEach(function (dot, dotIndex) {
      listen(dot, 'click', function () { show(dotIndex, true); });
    });
    listen(carousel, 'mouseenter', function () { setPaused(true); });
    listen(carousel, 'mouseleave', function () { setPaused(carousel.matches(':focus-within')); });
    listen(carousel, 'focusin', function () { setPaused(true); });
    listen(carousel, 'focusout', function () {
      window.setTimeout(function () { setPaused(carousel.matches(':hover') || carousel.matches(':focus-within')); }, 0);
    });
    listen(carousel, 'pointerdown', function () { setPaused(true); });
    listen(carousel, 'pointerup', function () { setPaused(carousel.matches(':hover') || carousel.matches(':focus-within')); });
    listen(carousel, 'pointercancel', function () { setPaused(carousel.matches(':hover') || carousel.matches(':focus-within')); });
    listen(document, 'visibilitychange', schedule);
    listen(reducedMotion, 'change', schedule);

    instances.set(carousel, {
      destroy: function () {
        clearTimers();
        listeners.forEach(function (remove) { remove(); });
        instances.delete(carousel);
      }
    });

    preloadNext();
    schedule();
  }

  function init(root) {
    findCarousels(root || document).forEach(createCarousel);
  }

  function destroy(root) {
    findCarousels(root || document).forEach(function (carousel) {
      var instance = instances.get(carousel);
      if (instance) instance.destroy();
    });
  }

  if (window[namespace]) {
    window[namespace].init(document);
    return;
  }

  window[namespace] = { init: init, destroy: destroy };
  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) { destroy(event.target); });
})();
